import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useAuditsTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
